import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("upus_token") || sessionStorage.getItem("upus_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("upus_token");
        sessionStorage.removeItem("upus_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, userData, remember = true) => {
    localStorage.removeItem("upus_token");
    sessionStorage.removeItem("upus_token");
    (remember ? localStorage : sessionStorage).setItem("upus_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("upus_token");
    sessionStorage.removeItem("upus_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
